'use client';

import type { AuditUiSource, ClientAuditAction } from 'pc-types';

import { authHeaders } from '@/lib/api';
import { fetchAccessToken } from '@/lib/auth-client';
import { BACKEND_URL } from '@/lib/constants';
import { reportError } from '@/lib/report-error';

/**
 * Fire-and-forget client-reported audit event (tab closes, link copies,
 * template previews). `keepalive: true` lets the request survive tab close;
 * sendBeacon can't carry the Authorization header, so it is not an option.
 */
export function recordClientAuditEvent(input: {
  action: ClientAuditAction;
  resourceId: string;
  uiSource?: AuditUiSource;
}): void {
  void (async () => {
    const token = await fetchAccessToken();
    if (!token) return;
    await fetch(`${BACKEND_URL}/audit/events`, {
      method: 'POST',
      keepalive: true,
      headers: authHeaders(token),
      body: JSON.stringify({
        action: input.action,
        resourceId: input.resourceId,
        ...(input.uiSource ? { metadata: { uiSource: input.uiSource } } : {}),
      }),
    });
  })().catch((error) => {
    reportError(error, { site: 'audit_client', action: input.action });
  });
}
